export const default_image = "/assets/images/Logo/coming_soon.jpeg";